import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
   name: 'requestType'
})

export class RequestType implements PipeTransform {
  transform(value: string): string {
      if (value && value !== ''){
          return value == "1" ? "Housing Request" : "Financial Assistance";
      }else{
          return '';
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/_pipes/requestType.ts